'use strict';

var React = require('react');
var styles$1 = require('../../Checkbox/styles.js');
var text = require('../../../../helpers/text.js');
var index = require('../../../Flex/index.js');
var component = require('../../../Text/component.js');
var styles = require('../styles.js');
var context = require('../context.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const SelectOptionMulti = React.forwardRef(({ value, label, isPlaceholder, index: index$1, className, disabled, ...props }, ref) => {
    const { values: selectedValues, formatLabel, onChange, indexOfFocusedItem } = context.useSelectContext();
    const labelFromValue = formatLabel(value);
    const isSelected = React.useMemo(() => {
        if (value === undefined || !selectedValues)
            return false;
        if (typeof value === 'string')
            return selectedValues.includes(value);
        return selectedValues.some(v => {
            const fieldName = Object.prototype.hasOwnProperty.call(value, 'id') ? 'id' : 'value';
            return v[fieldName] === value[fieldName];
        });
    }, [selectedValues, value]);
    const handleClick = (event) => {
        if (isPlaceholder) {
            return event.preventDefault();
        }
        const target = event.target;
        target.blur();
        onChange(value, index$1);
    };
    return (React__default.default.createElement(styles.Styled.DropdownOption, { ...props, className: text.classNames(isSelected && 'focus', indexOfFocusedItem === index$1 && 'hover', className), ref: ref, role: "option", "aria-selected": isSelected, onClick: handleClick, onFocus: e => e.stopPropagation(), isPlaceholder: isPlaceholder, disabled: disabled },
        React__default.default.createElement(index.Flex.Row, { space: "s" },
            React__default.default.createElement(styles.Styled.CheckboxContainer, null,
                React__default.default.createElement(styles$1.Styled.Input, { disabled: disabled, type: "checkbox", checked: isSelected, readOnly: true }),
                React__default.default.createElement(styles$1.Styled.Box, null)),
            React__default.default.createElement(component.Text, { variant: "body-lighter" }, label ?? labelFromValue))));
});
SelectOptionMulti.displayName = 'Select.OptionMulti';

exports.SelectOptionMulti = SelectOptionMulti;
//# sourceMappingURL=OptionMulti.js.map
